/* WS2: read cart state and delegate sticky purchase actions to Impulse. */
(function () {
  'use strict';
  // Free standard shipping (A$249) is for Australian addresses only.
  function shippingState(cart, threshold, country) {
    if (country !== 'AU') return null;
    if (!cart || cart.currency !== 'AUD' || !Number.isFinite(cart.total_price) ||
        cart.total_price < 0 || !Number.isFinite(threshold) || threshold <= 0) return null;
    // Digital-only baskets must not suggest adding merchandise for shipping.
    if (Array.isArray(cart.items) && cart.items.length &&
        cart.items.every(function (item) { return item.requires_shipping === false; })) return null;
    return { remaining: Math.max(threshold - cart.total_price, 0),
      progress: Math.min(100, Math.round(cart.total_price / threshold * 100)) };
  }
  function nativePurchaseState(button, price) {
    return { disabled: !button || button.disabled || button.classList.contains('btn--loading'),
      label: button ? button.textContent.trim() : '',
      price: price ? price.textContent.trim() : '' };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { shippingState: shippingState, nativePurchaseState: nativePurchaseState };
  }
  if (typeof document === 'undefined') return;
  if (window.__bcStorefront) return;
  window.__bcStorefront = true;
  var revision = 0;
  function applyCart(cart) {
    document.querySelectorAll('[data-boss-fs]').forEach(function (bar) {
      var country = String(bar.dataset.country || (window.Shopify && window.Shopify.country) || '').toUpperCase();
      var state = shippingState(cart, Number(bar.dataset.threshold), country);
      bar.hidden = !state;
      if (!state) return;
      var amount = 'A$' + new Intl.NumberFormat('en-AU', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(state.remaining / 100);
      bar.querySelector('[data-boss-fs-message]').textContent = state.remaining ?
        bar.dataset.remaining.replace('[amount]', amount) : bar.dataset.reached;
      bar.querySelector('[data-boss-fs-progress]').value = state.progress;
    });
    if (cart && /^[A-Z]{3}$/.test(cart.currency)) {
      document.querySelectorAll('[data-bc-currency]').forEach(function (notice) {
        notice.textContent = notice.dataset.template.replace('[currency]', cart.currency);
      });
    }
  }
  function refreshCart() {
    var request = ++revision;
    // Never leave stale progress visible while the authoritative cart is unknown.
    document.querySelectorAll('[data-boss-fs]').forEach(function (bar) { bar.hidden = true; });
    var route = window.theme && window.theme.routes && window.theme.routes.cart;
    if (!route) return;
    fetch(route, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(function (cart) { if (request === revision) applyCart(cart); })
      .catch(function () { /* Native cart remains usable; progress stays hidden. */ });
  }
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) { ++revision; applyCart(event.detail.cart); }
    else refreshCart();
  });
  document.addEventListener('ajaxProduct:added', refreshCart);
  window.addEventListener('pageshow', function (event) { if (event.persisted) refreshCart(); });

  class BossStickyCart extends HTMLElement {
    connectedCallback() {
      this.main = document.querySelector('#MainContent [data-section-type="product"][data-product-id="' + this.dataset.productId + '"]');
      this.nativeButton = this.main && this.main.querySelector('form.product-single__form [data-add-to-cart]');
      this.button = this.querySelector('[data-sticky-atc-button]');
      this.price = this.main && this.main.querySelector('[data-product-price]');
      if (!this.nativeButton || !this.button) { this.hidden = true; return; }
      this.sync = this.update.bind(this);
      this.purchase = () => {
        this.update();
        if (!this.button.disabled) this.nativeButton.click();
        this.update();
      };
      this.button.addEventListener('click', this.purchase);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      this.overlayObserver = new MutationObserver(this.sync);
      this.overlayObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('scroll', this.sync, { passive: true });
      window.addEventListener('resize', this.sync);
      this.update();
    }
    update() {
      var state = nativePurchaseState(this.nativeButton, this.price);
      this.button.disabled = state.disabled;
      this.querySelector('[data-sticky-button-text]').textContent = state.label;
      this.querySelector('[data-sticky-price]').textContent = state.price;
      var blocked = document.documentElement.matches('.js-drawer-open, .modal-open');
      this.hidden = blocked || this.nativeButton.getBoundingClientRect().bottom >= 0;
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.overlayObserver) this.overlayObserver.disconnect();
      if (this.button) this.button.removeEventListener('click', this.purchase);
      window.removeEventListener('scroll', this.sync);
      window.removeEventListener('resize', this.sync);
    }
  }
  if (!customElements.get('bc-sticky-cart')) customElements.define('bc-sticky-cart', BossStickyCart);
})();
